"use client";

import { useParams } from "next/navigation";
import Container from "~/components/common/container";
import Heading from "~/components/common/heading";
import ProductReel from "~/components/product/product-reel";
import { Separator } from "~/components/ui/separator";

export default function CategoryItemPage() {
  const params = useParams();
  const { slug = "" } = params as Record<string, string>;
  const categoryName = slug
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
  return (
    <Container className="p-4 lg:p-8">
      <div className="flex items-center justify-between">
        <Heading title={`Category: ${categoryName}`} />
        {/* <Button className="flex items-center normal-case gap-1 font-medium truncate" onClick={handleOpen}>
                    <FilterIcon className="size-4" />
                    <span className="hidden md:block">Filter</span>
                </Button> */}
      </div>
      <Separator className="mt-4 mb-8 shrink-0" />
      <div className="flex gap-5">
        <div className="flex-[5]">
          <ProductReel query={{ limit: 12, category: slug }} />
        </div>
      </div>
    </Container>
  );
}
